import { createAction } from 'redux-actions';

export const carClaimFetch = createAction('USER_DASHBOARD_CAR_CLAIM_FETCH');
export const carClaimSet = createAction('USER_DASHBOARD_CAR_CLAIM_SET');
